import {getToken} from "@/helpers/auth/auth-helper";
import {getArea, getLength} from "ol/sphere";
import {getLocationById, getLocationByLngLat} from "@/http/services/http-services-route";
import {getCenter} from "ol/extent";
import {
    hasDefaultValueParams,
    replaceDefaultValueParams
} from "@/helpers/datatable/datatable-editor-replace-param-helper";
import {stopLadda} from "@/helpers/ladda-helper";
import {WKT} from "ol/format";
import {generateGeoJsonObjectFromFeature} from "@/helpers/ol/ol-geo-json-helper";
import {getBySelector, getHtmlByText} from "@/helpers/element-helper";
import {refreshAllActiveLayers, removeLayer} from "@/helpers/ol/ol-layer-helper";
import {getMutationLayerName} from "@/helpers/tools/tools-mutation-helper";
import {disableMoveLayer} from "@/helpers/ol/map/ol-move-helper";
import {Circle} from "ol/geom.js";
import {fromCircle} from "ol/geom/Polygon";
import {Point} from "ol/geom";
import loadImage from 'blueimp-load-image'
import {updateEditorTokens} from "@/helpers/datatable/datatable-editor-helper.js";
import DOMPurify from "dompurify";
import {escapeOutput} from "@/helpers/output-helper.js";
import {isValidUrl} from "@/helpers/url/url-params-helper.js";
import fi from "datatables.net-plugins/i18n/fi.mjs";

let preUploadedFileNames = []
let uploadedFileNames = []
let preUploadedFileNameLoaded = 0

export function initDataTableEditorEvents(dataTable, editor, editorOptions, rowData, table, geometry, editorMessage = '') {

    if(editorMessage) {
        editor.message(editorMessage)
        // Clear dynamic fields because it's only geometry
        if(editorMessage.includes('Hiermee wordt de geometrie')) {
            editorOptions.dynamicFields = []
        }
    }

    let init = true
    editor.on( 'preOpen', (e, mode, action) => {
        preOpen(dataTable, editor, editorOptions, rowData, action, table, geometry, editorMessage, init)
        init = false
    });

    window.bootstrap.Modal.constructor.prototype.enforceFocus = function() {};

    console.log('init')

    editor.on( 'opened', (e, mode, action) => {



        stopLadda()

        document.querySelectorAll('button[tabindex]').forEach((button) => {
            button.removeAttribute('tabindex')
        })
    });

    editor.on( 'open', (e, mode, action) => {

        console.log(action)

        const editIDs = editor.ids()
        let editID
        if(editIDs.length === 1) {
            editID = editIDs[0]
            if(editID.includes('.')) {
                editID = editID.split('.')[1]
            }
        }

        if(editorMessage && editorMessage.includes('overlappende geometrie')) {
            // console.log('test')
            document.querySelector('.DTE_Form_Buttons .btn-warning').classList.remove('d-none')
        } else {
            document.querySelector('.DTE_Form_Buttons .btn-warning').classList.add('d-none')
        }

        stopLadda()

        document.querySelectorAll('button[tabindex]').forEach((button) => {
            button.removeAttribute('tabindex')
        })
    });

    editor.on( 'open', (e, mode, action) => {

        if(window.windowModalSettings.transform) {
            getBySelector('.DTE').style.transform = window.windowModalSettings.transform
            getBySelector('.DTE').style.width = window.windowModalSettings.width
            getBySelector('.DTE').style.height = window.windowModalSettings.height
        }

        document.querySelectorAll('.form-check-input').forEach(element => {
            const checkMandatory = element.closest('.DTE_Field').querySelector('.fa-mandatory')
            if(checkMandatory) {
                return
            }

            element.addEventListener('click', function(e) {
                if(element.type === 'radio') {
                    e.preventDefault()
                    setTimeout(() => {
                        const checked = e.target.checked
                        if (!checked) {
                            editor.field(element.name).set(element.value);
                        } else {
                            editor.field(element.name).set('');
                        }
                    }, 0)
                }
            })
        })
    })

    editor.on('submitError', () => {
        editor.message('<i class="fas fa-exclamation-triangle" style="margin-right: 2px;"></i>Je hebt geen rechten om op deze laag te muteren.');
        return false;
    })

    editor.on('preSubmit', (e, data, action) => {
        updateEditorTokens()

        if (action === 'create' || action === 'edit') {

            console.log(data)

            for (const rowId in data.data) {
                const row = data.data[rowId];
                for (const field in row) {
                    if (typeof row[field] === 'string' && !isValidUrl(row[field])) {
                        row[field] = DOMPurify.sanitize(escapeOutput(row[field]));
                    }
                }
            }
        }
    })

    editor.on('closed', (e, type) => {
        if(window.closeType && window.closeType === 'escape') {
            removeLayer(getMutationLayerName(), false)
            disableMoveLayer()
            refreshAllActiveLayers()
        }
    })

    editor.on('postUpload', () => {
        getBySelector('.DTE_Form_Buttons button').disabled = false
    });

    editor.on( 'preUpload', function ( e, fieldName, file, ajaxData ) {
        getBySelector('.DTE_Form_Buttons button').disabled = true

        if(isFileImage(file)) {
            const fileName = file.name
            const field = editorOptions.fields.find(field => field.name === fieldName)
            if (field.uploadText && field.opts.maxHeight && field.opts.maxHeight > 0) {
                return new Promise((resolve) => {
                    loadImage(
                        file,
                        function (canvas) {
                            canvas.toBlob(function(blob) {
                                console.log('verkleind')
                                if (blob) {
                                    // Create a File object from the Blob
                                    ajaxData.set('upload', new File([blob], fileName));
                                    resolve();
                                }
                            })
                        },
                        {
                            maxHeight: field.opts.maxHeight,
                            canvas: true
                        }
                    )
                })
            }
        }
    });

    return editor
}

function preOpen(dataTable, editor, editorOptions, rowData, action, table, geometry, editorMessage, init) {
    const fieldsToUpdate = []

    if (action === 'create') {

        if(window.mutation_geom || geometry) {
            let center
            if(window.mutation_geom) {
                center = getCenter(window.mutation_geom.getExtent())
            } else {
                center = getCenter(geometry.getExtent())
            }

            let hasDefaultValueParam = false
            editorOptions.fields.map(function (field) {
                if(hasDefaultValueParams(field.def))  {
                    hasDefaultValueParam = true
                    editor.field(field.name).set('');
                }

                editor = setAreaOrLength(editor, field, geometry)

                if(field.type === 'radio' && field.def !== '') {
                    editor.field(field.name).set(field.def);
                }
            })

            // Only call API when there are params inside
            if(hasDefaultValueParam && center) {
                getLocationByLngLat(center[0], center[1]).then((result) => {
                    getLocationById(result.adres.id).then(location => {
                        editorOptions.fields.map(function (field) {
                            const value = replaceDefaultValueParams(result, location.response.docs[0], field.def, center)
                            if (value) {
                                editor.field(field.name).set(value);
                            }
                        })
                    })
                })
            }
        }

        dataTable.attributes.map(attribute => {
            if(attribute.MutationTypeID === 27) {

                // console.log(dataTable.feature)

                const features = generateGeoJsonObjectFromFeature(dataTable.feature, false)
                const wkt = new WKT();
                geometry = wkt.writeGeometry(features[0].getGeometry())
                // console.log(geometry)
                editor.field(attribute.Attribute).set(geometry);
            }
        })

        // editorOptions.fields.map(function (field) {
        //     if (field.type === 'select2') {
        //         fieldsToUpdate.push({
        //             name: field.name,
        //             value: ''
        //         });
        //     }
        // })
    }

    if (action === 'edit') {
        editorOptions.fields.map(function (field) {

            const fieldName = field.name.replace('_old', '');

            if(table) {
                const rows = table.rows( { selected: true } )
                rows.every(function () {
                    rowData = this.data();

                    // Multiselect
                    let value = String(rowData[fieldName])
                    if(field.type === 'select2' && value.includes('data-value="')) {
                        const splitValue = value.split('data-value="')[1]
                        if(splitValue) {
                            value = value.split('data-value="')[1].split('"')[0]
                        }
                    }

                    if (field.name.includes("_old")) {

                        const id = rowData.featureid
                        const currentValue = editor.field(field.name.replace('_old', '')).multiGet(id)
                        editor.field(field.name).multiSet(id, currentValue);
                    } else {

                        if(field.type === 'select2') {
                            fieldsToUpdate.push({
                                name: field.name,
                                value: value
                            });

                            if(value.includes('data-value="')) {
                                const splitValue = rowData[fieldName].split('data-value="')[1]
                                if (splitValue) {
                                    editor.field(field.name).set(value);
                                }
                            }
                        }

                        editor = setAreaOrLength(editor, field, geometry)
                    }

                })
            } else {

                let value = rowData[fieldName]
                if(field.type === 'select2') {
                    const splitValue = rowData[fieldName].split('data-value="')[1]
                    if(splitValue) {
                        value = rowData[fieldName].split('data-value="')[1].split('"')[0]
                    }
                }

                if(field.type === 'radio' && field.def !== '' && value === '') {
                    editor.field(field.name).set(field.def);
                }

                if (field.name.includes("_old")) {
                    editor.field(field.name).set(value);
                } else {

                    if(field.type === 'select2') {
                        fieldsToUpdate.push({
                            name: field.name,
                            value: value
                        });

                        const splitValue = rowData[fieldName].split('data-value="')[1]
                        if(splitValue) {
                            editor.field(field.name).set(value);
                        }
                    }

                    if(field.type === 'upload' || field.type === 'uploadMany') {
                        if(field.opts.action !== 1) {
                            if(!editorMessage.includes('Hiermee wordt de geometrie')) {
                                editor.field(field.name).set(value);
                            }
                        }
                    }

                    editor = setAreaOrLength(editor, field, geometry)
                }
            }
        });
    }

    if(init) {
        editorOptions.dynamicFields.map(postData => {

            if (window.result && window.result.mainTabs && window.result.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === dataTable.BookmarkPresentationID)) {
                const mainTab = window.result.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === dataTable.BookmarkPresentationID).features[0]

                if (mainTab) {
                    let featureInfo

                    mainTab.featureInfo.map((featureInfoItem) => {
                        if (featureInfoItem.keyColumnDistance && featureInfoItem.keyColumnDistance > 0) {
                            featureInfo = featureInfoItem
                        }
                    })

                    if (featureInfo) {

                        let linkedAttribute

                        mainTab.featureInfo.find(featureInfo => featureInfo.FormID === dataTable.FormID).records[0].attributes.map(attribute => {
                            attribute.map(attributeItem => {
                                if (attributeItem.FormAttributeID === postData.column && attributeItem.DomainList && attributeItem.DomainList.AttributeLinkedAttribute) {
                                    linkedAttribute = attributeItem.DomainList.AttributeLinkedAttribute
                                }
                            })
                        })

                        if (linkedAttribute && postData.columnName === featureInfo.keyColumnLinkedAttribute) {
                            if (!geometry) {
                                geometry = new Point(mainTab.feature.geometry.coordinates)
                            }

                            postData.columns = [
                                {data: linkedAttribute},
                                {data: featureInfo.keyColumn},
                            ]

                            postData.geomtryCheck = 'true'
                            postData.querytype = 'WITHIN'
                            const radiusDutch = featureInfo.keyColumnDistance / 1.9 // 3000 = 5 km

                            const circle = new Circle(geometry.getFlatCoordinates(), radiusDutch)
                            postData.geometry = {
                                coord: fromCircle(circle.clone()).getFlatCoordinates()
                            }
                        }
                    }
                }
            }

            console.log(postData)

            postData.child_name = loadDynamicField(dataTable, editor, fieldsToUpdate, postData)
        })

        console.log(editorOptions)

        editorOptions.dynamicFields.map(postData => {
            // console.log(postData)
            if (postData.child_name) {

                editor.dependent(postData.columnName, function (val, data, callback, e) {

                    setTimeout(() => {
                        const formAttributeID = dataTable.attributes.find(attribute => attribute.Attribute === postData.child_name).FormAttributeID

                        if(table) {
                            const dataTableData = table.rows({selected: true}).data()[0]

                            if(dataTableData) {
                                if (!fieldsToUpdate.find(field => field.name === postData.child_name)) {
                                    let fieldValue = getHtmlByText(dataTableData[postData.child_name])?.firstChild?.dataset?.value
                                    fieldsToUpdate.push({
                                        name: postData.child_name,
                                        value: fieldValue
                                    });
                                }


                                fieldsToUpdate.map(field => {
                                    field.value = getHtmlByText(dataTableData[field.name])?.firstChild?.dataset?.value
                                })
                            }
                        }

                        data = {
                            columnName: postData.child_name,
                            column: formAttributeID,
                            parentValue: val
                        }

                        loadDynamicField(dataTable, editor, fieldsToUpdate, data)

                        callback(true);
                    }, 0)
                });
            }
        })
    }
}

function loadDynamicField(dataTable, editor, fieldsToUpdate, postData) {

    let childName
    const Http = new XMLHttpRequest();
    Http.open('POST', window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/' + dataTable.DomainID + '/presentation/' + dataTable.PresentationID + '/filter/' + dataTable.FormID + '?request=unique&trekking=1&ts=' + new Date().getTime(), false);
    Http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    Http.setRequestHeader("Cache-Control", "no-cache, no-store, max-age=0");

    let token = getToken()
    if(token !== undefined) {
        Http.setRequestHeader("Authorization", token);
    }

    const attribute = dataTable.attributes.find(attribute => attribute.Attribute === postData.columnName)
    const domainListDependentParent = attribute.DomainList.domain_list_dependent_parent
    if(domainListDependentParent) {
        postData.parentValue = editor.field(domainListDependentParent.Attribute).val()
    }

    if(!postData.parentValue) {
        const parentAttribute = dataTable.dynamicSelect.find(dynamicSelect => dynamicSelect.child_name === postData.columnName)
        if (parentAttribute) {
            postData.parentValue = editor.field(parentAttribute.columnName).val()
        }
    }

    const dynamicSelect = dataTable.dynamicSelect.find(dynamicSelect => dynamicSelect.columnName === postData.columnName)

    Http.send(JSON.stringify(postData));

    if (Http.status === 200) {
        const options = []
        const response = JSON.parse(Http.responseText)
        if(response) {
            response.features.map(item => {
                options.push({label: item.properties.name, value: item.properties.value})

                if(item.properties.attr) {
                    childName = item.properties.attr.child_name
                }
            })
            editor.field(postData.columnName).update(options);

            console.log(fieldsToUpdate)
            console.log(postData)

            if(fieldsToUpdate.length > 0) {
                fieldsToUpdate.map((field) => {
                    if(field.name === postData.columnName && field.value) {
                        editor.field(field.name).set(field.value);

                        if(!editor.val(field.name) && options.length > 0) {
                            editor.field(field.name).set(options[0].value);
                        }
                    }
                })
            } else {
                if(options.length > 0) {
                    editor.field(postData.columnName).set(editor.field(postData.columnName).def());
                }
            }
        }
    }

    if(!childName) {
        return dynamicSelect.child_name
    }

    return childName
}

function setAreaOrLength(editor, field, geometry) {
    if(geometry && typeof geometry !== 'string' && field.opts) {
        if(field.opts.type === 'length') {
            editor.field(field.name).set(getLength(geometry).toFixed(2));
        }
        if(field.opts.type === 'area') {
            editor.field(field.name).set(getArea(geometry).toFixed(2));
        }
    }
    return editor
}

function isFileImage(file) {
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
    return file && acceptedImageTypes.includes(file['type'])
}
